import { inject, Injectable } from '@angular/core';
import {
  FormControl,
  NonNullableFormBuilder,
  Validators,
} from '@angular/forms';
import { FILTER_PATTERNS } from '@shared/constants';
import { ForgotPasswordFormControls } from '../enums/forgot-password-form-controls.enum';

@Injectable()
export class ForgotPasswordFormService {
  private readonly _fb = inject(NonNullableFormBuilder);

  public readonly formControls = ForgotPasswordFormControls;

  public readonly form = this._fb.group({
    [ForgotPasswordFormControls.EMAIL]: new FormControl('', {
      validators: [
        Validators.required,
        Validators.pattern(FILTER_PATTERNS.email),
      ],
      nonNullable: true,
    }),
  });
}
